// extracted by mini-css-extract-plugin
export var addedtobasketbanner = "SADProfilePage-module--addedtobasketbanner--dfe88";
export var addedtobasketbannerlink = "SADProfilePage-module--addedtobasketbannerlink--a6451";
export var addedtobasketbannertitle = "SADProfilePage-module--addedtobasketbannertitle--65372";
export var border = "SADProfilePage-module--border--400ac";
export var continuetobasket = "SADProfilePage-module--continuetobasket--3ce23";
export var dogdetails = "SADProfilePage-module--dogdetails--6eae6";
export var dogdetailstext = "SADProfilePage-module--dogdetailstext--c8293";
export var likesbordersectionbottom = "SADProfilePage-module--likesbordersectionbottom--91bbc";
export var likesbordersectiontop = "SADProfilePage-module--likesbordersectiontop--bb195";
export var likescontent = "SADProfilePage-module--likescontent--ef328";
export var likesicon = "SADProfilePage-module--likesicon--a4246";
export var likessection = "SADProfilePage-module--likessection--64364";
export var likestext = "SADProfilePage-module--likestext--446e3";
export var noquote = "SADProfilePage-module--noquote--a404c";
export var quote = "SADProfilePage-module--quote--57c4c";
export var quotee = "SADProfilePage-module--quotee--287e6";
export var quoteerole = "SADProfilePage-module--quoteerole--253f7";
export var quotemarks = "SADProfilePage-module--quotemarks--29b0d";
export var quotesbordersection = "SADProfilePage-module--quotesbordersection--1a100";
export var quotesection = "SADProfilePage-module--quotesection--62f19";
export var quotetext = "SADProfilePage-module--quotetext--67813";
export var sharetoicons = "SADProfilePage-module--sharetoicons--807c1";
export var sharetolabel = "SADProfilePage-module--sharetolabel--6f5c2";
export var slideUp = "SADProfilePage-module--slideUp--8254f";
export var socialmediawrapper = "SADProfilePage-module--socialmediawrapper--684ac";
export var sponsororsocial = "SADProfilePage-module--sponsororsocial--89323";
export var textsection = "SADProfilePage-module--textsection--85031";